import { FC, useCallback, useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';

import { MEDIA_QUERIES, useNavigation } from '#/hooks';
import { remify } from '#/service/utils';

interface Props {
  className?: string;
  onClick?: () => void;
  isSecondary?: boolean;
}

const StyledImage = styled.img`
  ${(props) => !props.src && 'display: none;'}
  max-width: ${remify(100)};
  max-height: ${remify(80)};
  cursor: pointer;
`;

export const Logo: FC<Props> = ({ className, isSecondary, onClick }) => {
  const { goHome } = useNavigation('Logo');
  const theme = useTheme();

  const [isError, setIsError] = useState(false);

  const logoSrc = isSecondary ? theme.logo?.secondary : theme.logo?.primary;
  const fallbackSrc = theme.images.appLogo;
  const src = logoSrc || fallbackSrc;

  useEffect(() => {
    setIsError(false);
  }, [src]);

  const onError = useCallback(() => setIsError(true), []);

  if (isError) {
    return null;
  }

  return (
    <StyledImage
      alt="logo"
      className={className}
      data-testid="app-logo"
      onClick={onClick ?? goHome}
      onError={onError}
      src={src}
    />
  );
};

// for pages without Menu, that still need a logo in the corner
export const LogoContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  margin: ${remify(30)} 0 0 ${remify(50)};
  padding: 0;

  /* cenetered & scrolling with the content on small screens */
  @media ${MEDIA_QUERIES.md} {
    position: absolute;
    box-sizing: border-box;
    margin: 0;
    padding: ${remify(5)};
    width: 100%;
    height: ${remify(80)};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

LogoContainer.displayName = 'LogoContainer';
